var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJpeg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.75V5.59375C4 5.17106 4.18154 4.76568 4.50468 4.4668C4.82782 4.16791 5.26609 4 5.72308 4H17.9328C18.3896 4.00037 18.8276 4.16853 19.1504 4.4675L25.8957 10.7054C26.0557 10.8535 26.1826 11.0293 26.2691 11.2227C26.3556 11.4161 26.4001 11.6234 26.4 11.8327V16.75",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4001 12.25H19.3601C18.8933 12.25 18.4457 12.0762 18.1156 11.7667C17.7855 11.4573 17.6001 11.0376 17.6001 10.6V4",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 19.75V26.35C7.2 26.7876 7.03143 27.2073 6.73137 27.5167C6.43131 27.8262 6.02435 28 5.6 28H4",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.729 27.9999V20.0001",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.729 20.0001H11.5823C12.2613 20.0001 12.9124 20.253 13.3925 20.7031C13.8726 21.1531 14.1423 21.7636 14.1423 22.4001C14.1423 23.0366 13.8726 23.647 13.3925 24.0971C12.9124 24.5472 12.2613 24.8 11.5823 24.8H10.729",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1115 27.9999H19.4049C18.9522 27.9999 18.5182 27.8314 18.1981 27.5313C17.878 27.2313 17.6982 26.8243 17.6982 26.4V21.6001C17.6982 21.1757 17.878 20.7688 18.1981 20.4687C18.5182 20.1687 18.9522 20.0001 19.4049 20.0001H21.1115",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6982 24.8002H21.1115",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1998 24.7H27.9998V26.35C27.9998 26.7876 27.8312 27.2073 27.5312 27.5167C27.2311 27.8262 26.8242 28 26.3998 28C25.9755 28 25.5685 27.8262 25.2684 27.5167C24.9684 27.2073 24.7998 26.7876 24.7998 26.35V21.4C24.7998 20.9624 24.9684 20.5427 25.2684 20.2333C25.5685 19.9238 25.9755 19.75 26.3998 19.75H27.9998",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpeg);
export default __webpack_public_path__ + "static/media/jpeg.bcf892bea93cbe7383be742821cc538a.svg";
export { ForwardRef as ReactComponent };